 <template>
    <div class="row">
      <div class="col-md-4">
      </div>
        <div class="col-lg-3 col-md-4" style="text-align: center;">
            <div class="login-panel panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">تسجيل الدخول</h3>
                </div>
                <div class="panel-body">
                  <div class="alert alert-danger alert-dismissable" v-if="error">
                        {{error}}
                  </div>
                    <form role="form">
                        <fieldset>
                            <div class="form-group">
                                <input class="form-control" placeholder="اسم المستخدم" v-model="userName" name="userName" type="text" autofocus>
                            </div>
                            <div class="form-group">
                                <input class="form-control" placeholder="كلمة المرور" v-model="password" name="password" type="password" value="">
                            </div>
                            <!-- Change this to a button or input when using this as a form -->
                            <div class="form-group">
                                <button type="submit" class="btn btn-info btn-block" @click.prevent="performLogin" > دخول </button>
                            </div>
                        </fieldset>
                    </form>
                    <div style="margin: 0px 5px 0px 0px ">
                      <h5><small>app version: {{appVersion}}  powered by Tbaark Co</small></h5>
                    </div>
                </div>
            </div>
            <div>
              <vue-element-loading size="64" is-full-screen :active="isLoading" text="جارى تسجيل الدخول" spinner="bar-fade-scale" color="#A4A4A4"/>
            </div>
        </div>
    </div>
</template>
<style >
#inner {
display: table;
margin: 0 auto;
border: 1px solid black;
}

#outer {
border: 1px solid red;
width:100%
}
</style>
<script>
import axios from 'axios'
import {version} from '../../package'
import { isMobile } from 'mobile-device-detect'
export default {
  name: 'Login',
  data () {
    return {
      isBrowser: isMobile ? 'mobile' : 'Browser',
      appVersion: version,
      userName: '',
      password: '',
      error: '',
      isLoading: false
    }
  },
  methods: {
    performLogin () {
      var hostName = location.host
      this.isLoading = true
      axios.post(this.$apiURL + 'auth/login', {
        username: this.userName,
        password: this.password,
        isBrowser: this.isBrowser
      })
        .then(res => {
          this.isLoading = false
          if (res.data.isTechnical === true) {
            localStorage.setItem('token', res.data.access_token)
            localStorage.setItem('name', res.data.name)
            this.$router.push('/gps')
          } else {
            sessionStorage.setItem('isLogin', 'true')
            localStorage.setItem('avt_img', res.data.avt_img)
            localStorage.setItem('BrancheID', res.data.BrancheID)
            localStorage.setItem('user_id', res.data.user_id)
            localStorage.setItem('UID', res.data.UID)
            localStorage.setItem('token', res.data.access_token)
            localStorage.setItem('main_data', JSON.stringify(res.data.main_data))
            localStorage.setItem('Items', JSON.stringify(res.data.Items))
            localStorage.setItem('Branches', JSON.stringify(res.data.Branches))
            localStorage.setItem('Gov', JSON.stringify(res.data.Gov))
            localStorage.setItem('typeID', JSON.stringify(res.data.typeID))
            localStorage.setItem('dba', JSON.stringify(res.data.dba))
            localStorage.setItem('Per', JSON.stringify(res.data.Per))
            localStorage.setItem('call_statuses', JSON.stringify(res.data.call_statuses))
            localStorage.setItem('call_types', JSON.stringify(res.data.call_types))
            localStorage.setItem('call_actions', JSON.stringify(res.data.call_actions))
            localStorage.setItem('notificationChannels', JSON.stringify(res.data.notification_channels))
            this.$per.value = JSON.parse(localStorage.getItem('Per'))
            if (this.userName.toUpperCase() === 'DBA' && this.isBrowser === 'Browser' && hostName === 'system.powerlifefilters.com') {
              this.$router.push('/mobileactive')
            } else {
              this.$router.push('/dashborad')
            }
          }
        })
        .catch(err => {
          if (err.response.data.error === 'Forbidden') {
            this.error = 'خطأ فى اسم المستخدم او كلمة المرور'
          }
          if (err.response.data.error === 'Unauthorized') {
            this.error = 'الحساب غير نشط'
          }
          if (err.response.data.error === 'ip access denied') {
            this.error = 'عفوا لا يمكن الوصول للنظام من خارج الشركة'
          }
          if (err.response.data.error === 'mobile access denied') {
            this.error = 'عفوا لا تمتلك صلاحية الدخول من خلال الموبايل'
          }
          this.isLoading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue